module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.additional_fields', {
    tagname: _vm.tagName
  })))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-table', {
    attrs: {
      "data": _vm.resultFields,
      "striped": true,
      "narrowed": false,
      "mobile-cards": true,
      "paginated": false,
      "per-page": 10,
      "pagination-simple": true,
      "default-sort": "['type', 'desc']"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "name",
            "label": _vm.$t('index.name'),
            "width": "210"
          }
        }, [(props.row.type === 1 && _vm.erroredFiedls[props.index]) ? _c('b-field', {
          attrs: {
            "type": "is-danger",
            "message": _vm.$t('index.additional_fields_message')
          }
        }, [_c('b-input', {
          on: {
            "input": function($event) {
              _vm.validateCustomType($event, props.index)
            }
          },
          model: {
            value: (props.row.name),
            callback: function($$v) {
              _vm.$set(props.row, "name", $$v)
            },
            expression: "props.row.name"
          }
        })], 1) : _vm._e(), _vm._v(" "), (props.row.type === 1 && !_vm.erroredFiedls[props.index]) ? _c('b-field', [_c('b-input', {
          on: {
            "input": function($event) {
              _vm.validateCustomType($event, props.index)
            }
          },
          model: {
            value: (props.row.name),
            callback: function($$v) {
              _vm.$set(props.row, "name", $$v)
            },
            expression: "props.row.name"
          }
        })], 1) : _vm._e(), _vm._v(" "), (props.row.type !== 1) ? _c('span', [_vm._v(_vm._s(props.row.name))]) : _vm._e()], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": _vm.$t('index.default_value'),
            "field": "value",
            "width": "200"
          }
        }, [_c('b-field', [(props.row.value) ? _c('b-input', {
          attrs: {
            "disabled": _vm.isEditable(props.row.name),
            "expanded": ""
          },
          model: {
            value: (props.row.value),
            callback: function($$v) {
              _vm.$set(props.row, "value", $$v)
            },
            expression: "props.row.value"
          }
        }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": _vm.$t('index.edit_by_customer'),
            "field": "edit",
            "width": "40",
            "centered": ""
          }
        }, [_c('b-checkbox', {
          attrs: {
            "type": "is-info",
            "disabled": props.row.type !== 1
          },
          model: {
            value: (props.row.edit),
            callback: function($$v) {
              _vm.$set(props.row, "edit", $$v)
            },
            expression: "props.row.edit"
          }
        })], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "tools",
            "label": "",
            "width": "40",
            "centered": ""
          }
        }, [_c('button', {
          staticClass: "button is-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.deleteField(props.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('index.delete')))])])]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "buttons has-addons is-centered"
  }, [_c('button', {
    staticClass: "button is-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAvailableFields
    }
  }, [_vm._v(_vm._s(_vm.$t('index.add_field')))])])], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot  columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.close')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [(!_vm.validateCustomFieldError) ? _c('button', {
    staticClass: "button is-info ",
    on: {
      "click": _vm.saveFileds
    }
  }, [_vm._v(_vm._s(_vm.$t('index.save_and_close')))]) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isShowAvailableFields,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isShowAvailableFields = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto",
      "min-width": "300px"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('span', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.select_fields')) + "\n\n        ")]), _vm._v(" "), (_vm.checkedAvailableFields.length) ? _c('span', {
    staticClass: "button is-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addFiled
    }
  }, [_vm._v(_vm._s(_vm.$t('index.add_selected')))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body",
    staticStyle: {
      "max-height": "350px"
    }
  }, [_c('b-table', {
    attrs: {
      "data": _vm.availableFields,
      "checked-rows": _vm.checkedAvailableFields,
      "checkable": ""
    },
    on: {
      "update:checkedRows": function($event) {
        _vm.checkedAvailableFields = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "name",
            "label": _vm.$t('index.name'),
            "width": "210"
          }
        }, [_vm._v("\n              " + _vm._s(props.row.name) + "\n\n            ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "name",
            "label": _vm.$t('index.type'),
            "width": "210"
          }
        }, [_vm._v("\n              " + _vm._s(props.row.type !== 1 ? _vm.$t('index.system_field') : _vm.$t('index.custom_field')) + "\n              ")])]
      }
    }])
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f183350e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/mini_components/Tagfields.vue
// module id = 324
// module chunks = 2